import { OnboardingGettingStartedTrack } from "@/components/onboarding-banner";
import { cn } from "@/lib/utils";

interface DashboardWelcomeBannerProps {
  firstName: string;
  className?: string;
}

/**
 * Welcome strip with a dedicated left accent bar (not `border-left` on the rounded
 * shell) so corners stay clean, plus embedded getting-started progress when shown.
 */
export const DashboardWelcomeBanner = ({ firstName, className }: DashboardWelcomeBannerProps) => (
  <section
    aria-labelledby="dashboard-welcome-heading"
    className={cn("flex border border-border/85 bg-sidebar", className)}
  >
    {/* Negative margins extend the bar 1px past the section border on left, top, and bottom
        so the gray border is fully covered on those edges. overflow-hidden is removed since
        we no longer have rounded corners that need clipping. */}
    <div className="-my-px -ml-px w-[3px] shrink-0 bg-[color:var(--ds-color-accent-primary)]" aria-hidden />
    <div className="min-w-0 flex-1 px-5 py-5 lg:px-6 lg:py-6">
      <h1 id="dashboard-welcome-heading" className="text-3xl font-bold tracking-tight">
        Welcome back, {firstName}
      </h1>
      <p className="mt-1 text-muted-foreground">Here&apos;s an overview of your account activity and usage.</p>
      <OnboardingGettingStartedTrack />
    </div>
  </section>
);
